import { lazy } from 'react';
import {getSubRoot} from "@/utils/utils";
import { SimpleLayoutType } from '../config';

import Loadable from '../components/Loadable';
import DashboardLayout from '../layout/Dashboard';
import PagesLayout from '../layout/Pages';
import SimpleLayout from '../layout/Simple';
import {Privacy} from "@/pages/extra-pages/PrivacyTermsOfService/Privacy";
import {TermOfService} from "@/pages/extra-pages/PrivacyTermsOfService/TermOfService";

const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));

const AppContactUS = Loadable(lazy(() => import('pages/contact-us')));

const BackupHomePage = Loadable(lazy(() => import('pages/backup-pages/BackupHome')));

const BackupRoutes =
    {
        path: getSubRoot(window.location.pathname),
        children: [
            {
                path: '',
                element: <DashboardLayout/>,
                children: [
                    {
                        path: 'backup',
                        element: <BackupHomePage />,
                    },
                    {
                        path: 'privacy_policy',
                        element: <Privacy/>
                    },
                    {
                        path: 'term_of_service',
                        element: <TermOfService/>
                    },
                ]
            },
            {
                path: 'maintenance',
                element: <PagesLayout />,
                children: [
                    {
                        path: '404',
                        element: <MaintenanceError />
                    },
                    {
                        path: '500',
                        element: <MaintenanceError500 />
                    },
                    {
                        path: 'under-construction',
                        element: <MaintenanceUnderConstruction />
                    },
                    {
                        path: 'coming-soon',
                        element: <MaintenanceComingSoon />
                    }
                ]
            },
            {
                path: '',
                element: <SimpleLayout layout={SimpleLayoutType.SIMPLE} />,
                children: [
                    {
                        path: 'contact-us',
                        element: <AppContactUS />
                    }
                ]
            }
        ]
    }

export default BackupRoutes